import { type SavedFilterCollection } from '@webapp/hooks/useSavedFilterManager/types'
import { type SavedFilter } from '@webapp/models/SavedFilter'
import { ApiClient } from '@webapp/services/api'

export const ENDPOINT = '/api/v3/saved-filters/'

export const SAVED_FILTER_URL = ENDPOINT

export interface CreateSavedFilterSchema {
  name: string
  collection: SavedFilterCollection
  filters: SavedFilter['filters']
}

export class SavedFilterAPI {
  static getCollection = (collection: SavedFilterCollection, params) => {
    return ApiClient.get<SavedFilter[]>(`${ENDPOINT}`, {
      params: {
        collection,
        ...params,
      },
    })
  }

  static saveFilters = (data: CreateSavedFilterSchema) => {
    return ApiClient.post<CreateSavedFilterSchema, SavedFilter>(ENDPOINT, data)
  }

  static editFilter = (id: SavedFilter['id'], data: SavedFilter) => {
    return ApiClient.put<CreateSavedFilterSchema, SavedFilter>(
      `${ENDPOINT}${id}/`,
      data
    )
  }

  static deleteFilter = (id: SavedFilter['id']) => {
    return ApiClient.delete<any, SavedFilter>(`${ENDPOINT}${id}/`)
  }
}
